import Swiper from 'swiper/swiper-bundle.min';
import 'swiper/swiper-bundle.min.css';
import { utils, store } from '@/core'
const { qs, qsa } = utils

export default function () {
    const threeCards = qsa('.threecards-swiper')
    threeCards &&
	threeCards.forEach(tcs => {
        new Swiper(tcs, {
            slidesPerView: 1.1,
            spaceBetween: 10,
            breakpoints: {
                600: {
                  slidesPerView: 2,
                  spaceBetween: 16
                },
                // when window width is >= 640px
                1000: {
                  slidesPerView: 3,
                  spaceBetween: 16
                }
              },
            pagination: {
                el: ".threecards-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".threecards-button-next",
                prevEl: ".threecards-button-prev",
            }
        });
    });
}